import { MEDIA_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    path: "/admin/media",
    name: "admin-media",
    component: () => import("@/views/media/Index.vue"),
    meta: {
      gate: MEDIA_ACCESS,
      requiresAuth: true,
      pageTitle: "Media Library",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Media Library",
          active: true,
          to: "",
        },
      ],
    },
  },
];